import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'accountNumberSansMerchantPrefix',
    standalone: false
})
export class AccountNumberSansMerchantPrefixPipe implements PipeTransform
{
    transform(accountNumber: string): string
    {
        if (!accountNumber || accountNumber.length < 6)
        {
            return accountNumber;
        }
        return accountNumber.substring(6);
    }
}